module.exports = __webpack_public_path__ + "f9293a984e9318c10323c7d87eb3c1c8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/cos/0C000007GK.png
// module id = 1521
// module chunks = 0